import type { NavigateFunction } from "react-router-dom";
import {
  userIsJobboardOnlyAccount,
  userNeedsJobBoardProfileCompletion,
} from "./jobboardProfileGate.ts";

export type JobboardGoogleRegistrationEntry = "header" | "apply";

export function navigateAfterJobboardGoogleLogin(
  navigate: NavigateFunction,
  userData: {
    rols?: { name?: string }[];
    type?: string | null;
    name?: string;
    last_name?: string;
    razon_social?: string;
  },
  options: {
    registrationEntry: JobboardGoogleRegistrationEntry;
    workOfferId?: string | number;
    isExternalOffer?: boolean;
  }
): void {
  const needsOnboarding = userNeedsJobBoardProfileCompletion(userData);
  const isJobboardOnly = userIsJobboardOnlyAccount(userData);

  if (options.registrationEntry === "header") {
    if (needsOnboarding) {
      navigate("/bolsadetrabajo/completar-perfil");
    } else if (isJobboardOnly) {
      navigate("/bolsadetrabajo/registro-exitoso");
    } else {
      navigate("/bolsadetrabajo");
    }
    return;
  }

  const id = options.workOfferId;
  if (needsOnboarding) {
    navigate("/bolsadetrabajo/completar-perfil", {
      state: {
        fromApply: true,
        offerId: id,
        isExternalOffer: options.isExternalOffer,
      },
    });
    return;
  }

  if (id != null) {
    navigate(`/bolsadetrabajo/${id}`, {
      state: options.isExternalOffer ? { openExternalApply: true } : undefined,
    });
  } else {
    navigate("/bolsadetrabajo");
  }
}
